export default __webpack_public_path__ + "static/media/logo165x90white.d82dd0d2.png";